// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8":"9323b137","58":"f0cba2ff","89":"ffcfbeae","137":"f0cba2ff","398":"9890bb13","464":"f0cba2ff","488":"0e50ce6f","577":"82a684cc","593":"da388b60","615":"00d2066c"}[chunkId] + ".chunk.css";
};